var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from '~/core/decorator';
var LegalCaseManageService = /** @class */ (function () {
    function LegalCaseManageService() {
    }
    /**
     * 法务待分配查询列表
     */
    LegalCaseManageService.prototype.waitDistribution = function (data, page, sort) {
        return this.netService.send({
            server: domainService.legalCaseManageController.waitDistribution,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 法务个人案件池查询列表
     */
    LegalCaseManageService.prototype.personalCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.legalCaseManageController.personalCasePool,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 法务团队案件池查询列表
     */
    LegalCaseManageService.prototype.teamCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.legalCaseManageController.teamCasePool,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 回收案件池查询列表
     */
    LegalCaseManageService.prototype.recoverCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.legalCaseManageController.recoverCasePool,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 结清案件池查询列表
     */
    LegalCaseManageService.prototype.settleCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.legalCaseManageController.settleCasePool,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 结清案件池查询列表
     */
    LegalCaseManageService.prototype.pauseCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.legalCaseManageController.pauseCasePool,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 归C案件池查询列表
     */
    LegalCaseManageService.prototype.returnCCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.legalCaseManageController.returnCCasePool,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 法务案件待分配手动分案预览
     */
    LegalCaseManageService.prototype.legalCaseManualDistribution = function (data) {
        return this.netService.send({
            server: domainService.legalCaseManageController.legalCaseManualDistribution,
            data: data,
        });
    };
    /**
     * 法务案件待分配手动分案确定分案
     */
    LegalCaseManageService.prototype.confirmDistributeCase = function (data) {
        return this.netService.send({
            server: domainService.legalCaseManageController.confirmDistributeCase,
            data: data,
        });
    };
    /**
     * 法务案件手动分案预览
     */
    LegalCaseManageService.prototype.reviewDistributeCase = function (data) {
        return this.netService.send({
            server: domainService.legalCaseManageController.reviewDistributeCase,
            data: data,
        });
    };
    /**
     * 案件回收
     */
    LegalCaseManageService.prototype.returnCase = function (data) {
        return this.netService.send({
            server: domainService.legalCaseManageController.returnCase,
            data: data,
        });
    };
    /**
     * 移入法务待分配
     */
    LegalCaseManageService.prototype.moveToWaitDistribution = function (data) {
        return this.netService.send({
            server: domainService.legalCaseManageController.moveToWaitDistribution,
            data: data,
        });
    };
    /**
     * 个人案件池查询列表逾期总金额
     */
    LegalCaseManageService.prototype.personalCasePoolAmount = function (data) {
        return this.netService.send({
            server: domainService.legalCaseManageController.personalCasePoolAmount,
            data: data
        });
    };
    /**
     * 团队案件池查询列表逾期总金额
     * @param data
     */
    LegalCaseManageService.prototype.teamCasePoolAmount = function (data) {
        return this.netService.send({
            server: domainService.legalCaseManageController.teamCasePoolAmount,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], LegalCaseManageService.prototype, "netService", void 0);
    return LegalCaseManageService;
}());
export { LegalCaseManageService };
